var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "client-user-header" }, [
    _c("div", { staticClass: "logo" }, [
      _c(
        "div",
        { staticClass: "logo-icon" },
        [
          _c("svg-icon", {
            staticStyle: { color: "#00338d" },
            attrs: { "icon-name": "logo-kpmg", size: "74" },
          }),
        ],
        1
      ),
      _c("span", { staticClass: "txt" }, [
        _vm._v(_vm._s(_vm.$t("COMMON_PROJECT_NAME"))),
      ]),
    ]),
    _c("div", { staticClass: "header-right" }, [
      _c(
        "div",
        { staticClass: "header-user-con" },
        [
          _c(
            "div",
            { staticClass: "btns" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: { placement: "bottom" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.fullscreen
                                  ? _vm.$t("full_no_screen")
                                  : _vm.$t("full_screen")
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        on: { click: _vm.handleFullScreen },
                      },
                      [
                        _c("svg-icon", {
                          staticStyle: { color: "#0d386d" },
                          attrs: {
                            "icon-name": _vm.fullscreen
                              ? "icon-Exit-fullscreen"
                              : "icon-fullscreen",
                            size: 16,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _c(
                "el-tooltip",
                {
                  attrs: { placement: "bottom" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [_vm._v(" " + _vm._s(_vm.$t("i18n_btn")) + " ")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c(
                      "div",
                      { staticClass: "btn", on: { click: _vm.changeI18n } },
                      [
                        _c("svg-icon", {
                          staticStyle: { color: "#0d386d" },
                          attrs: {
                            "icon-name":
                              this.$i18n.locale === "zh"
                                ? "icon-EN"
                                : "icon-CN",
                            size: 16,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _c(
                "el-tooltip",
                {
                  attrs: { placement: "bottom" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function () {
                        return [_vm._v(" " + _vm._s(_vm.$t("FAQ_TITLE")) + " ")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c(
                      "div",
                      { staticClass: "btn", on: { click: _vm.handleFaq } },
                      [
                        _c("svg-icon", {
                          staticStyle: { color: "#0d386d" },
                          attrs: { "icon-name": "icon-FAQ", size: 16 },
                        }),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-popover",
            {
              attrs: {
                placement: "bottom",
                trigger: "click",
                "popper-class": "qr-code-popover",
                "visible-arrow": false,
              },
            },
            [
              _c("img", {
                staticClass: "qr-code",
                attrs: {
                  src: _vm.$i18n.locale === "en" ? _vm.qrCodeEn : _vm.qrCodeCn,
                },
              }),
              _c("div", { staticClass: "qr-txt" }, [
                _c("p", { staticClass: "font-bold text1" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("newsMgt.title4")) +
                      "\n          "
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "qr",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("svg-icon", {
                    staticStyle: { color: "#fff" },
                    attrs: { "icon-name": "qr-code" },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }